module.exports = __webpack_public_path__ + "static/ARB_ILLUSTRATION_3-ae2082a3904e5ed09334b8b599fbb93a.jpg";